import React from "react";
import { useEffect, useRef, useState } from "react"
import logo from "../../assets/images/logo.png"
import { useParams, useLocation, useHistory, Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
import { logOut } from "./Authentication/logout";
import Cookies from 'js-cookie';
import { encryptSlug } from "../../util/encryption";
import axios from "axios";
import { baseUrl } from "../../api/common";

const Header = () => {



  const isAuthenticated = Cookies.get('memberUserId');
  const menuButtonRef = useRef(null)
  const navOverlayRef = useRef(null)
  const navMenuRef = useRef(null)

  useEffect(() => {
    const menuButton = menuButtonRef.current
    const navOverlay = navOverlayRef.current
    const navMenu = navMenuRef.current

    // Don't proceed if refs are missing
    if (!menuButton || !navOverlay || !navMenu) return

    // Function to toggle menu and overlay
    const toggleMenu = () => {
      const isOpen = menuButton.classList.contains("w--open")

      if (isOpen) {
        navOverlay.style.display = "block"
        navMenu.style.display = "block" // Show the menu
        navMenu.classList.add("w--nav-menu-open") // Add the open class
      } else {
        navOverlay.style.display = "none"
        navMenu.style.display = "none" // Hide the menu
        navMenu.classList.remove("w--nav-menu-open") // Remove the open class
      }
    }

    // Click handler for the menu button
    const handleMenuClick = () => {
      menuButton.classList.toggle("w--open")
      toggleMenu()
    }

    // Click handler for the overlay
    const handleOverlayClick = () => {
      menuButton.classList.remove("w--open")
      navOverlay.style.display = "none"
      navMenu.style.display = "none" // Hide the menu
      navMenu.classList.remove("w--nav-menu-open") // Remove the open class
    }

    // Click handler for the close button
    const navCloseButton = document.querySelector(".nav-close")
    if (navCloseButton) {
      navCloseButton.addEventListener("click", (e) => {
        e.preventDefault()
        menuButton.classList.remove("w--open")
        navOverlay.style.display = "none"
        navMenu.style.display = "none" // Hide the menu
        navMenu.classList.remove("w--nav-menu-open") // Remove the open class
      })
    }

    // Add event listeners
    menuButton.addEventListener("click", handleMenuClick)
    navOverlay.addEventListener("click", handleOverlayClick)

    // Initial state - hide menu on mobile by default
    if (window.innerWidth < 992) {
      navMenu.style.display = "none"
    } else {
      navMenu.style.display = "block"
    }

    // Handle window resize
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        navMenu.style.display = "block" // Always show on desktop
      } else if (!menuButton.classList.contains("w--open")) {
        navMenu.style.display = "none" // Hide on mobile if menu is closed
      }
    }

    window.addEventListener("resize", handleResize)

    // IMPORTANT: First, hide all nested dropdowns initially
    const nestedDropdowns = document.querySelectorAll(".nav-dropdown-list.d-1")
    nestedDropdowns.forEach((dropdown) => {
      dropdown.style.display = "none"
    })

    // Setup main dropdowns
    const setupMainDropdowns = () => {
      const mainDropdowns = document.querySelectorAll(".nav-dropdown")
      mainDropdowns.forEach((dropdown) => {
        const toggle = dropdown.querySelector(".navbar-toogle")
        const dropdownList = dropdown.querySelector(".nav-dropdown-list")

        if (!toggle || !dropdownList) return

        // For desktop: handle hover
        dropdown.addEventListener("mouseenter", () => {
          if (window.innerWidth >= 992) {
            // Only for desktop
            dropdownList.style.display = "block"

            // Add arrow indicator
            if (toggle.querySelector(".navbar-dropdown-toogle-image")) {
              toggle.querySelector(".navbar-dropdown-toogle-image").style.transform = "rotate(180deg)"
              toggle.querySelector(".navbar-dropdown-toogle-image").style.transition = "transform 0.2s"
            }

            // CRITICAL FIX: Hide all nested dropdowns when opening a parent dropdown
            // This ensures nested dropdowns don't automatically open
            const nestedDropdowns = document.querySelectorAll(".nav-dropdown-list.d-1")
            nestedDropdowns.forEach((nestedDropdown) => {
              nestedDropdown.style.display = "none"

              // Also reset any arrow indicators in sub-dropdowns
              const subToggles = document.querySelectorAll(".sub-navbar-toogle")
              subToggles.forEach((subToggle) => {
                const arrow = subToggle.querySelector(".navbar-dropdown-toogle-image")
                if (arrow) {
                  arrow.style.transform = "rotate(0deg)"
                }
              })
            })
          }
        })

        dropdown.addEventListener("mouseleave", () => {
          if (window.innerWidth >= 992) {
            // Only for desktop
            setTimeout(() => {
              if (!dropdown.matches(":hover")) {
                dropdownList.style.display = "none"

                // Reset arrow indicator
                if (toggle.querySelector(".navbar-dropdown-toogle-image")) {
                  toggle.querySelector(".navbar-dropdown-toogle-image").style.transform = "rotate(0deg)"
                }
              }
            }, 100)
          }
        })

        // For mobile: handle click
        toggle.addEventListener("click", (e) => {
          if (window.innerWidth < 992) {
            // Only for mobile
            e.preventDefault()
            e.stopPropagation()

            // Toggle this dropdown
            const isOpen = dropdownList.style.display === "block"
            dropdownList.style.display = isOpen ? "none" : "block"

            // Toggle arrow indicator
            if (toggle.querySelector(".navbar-dropdown-toogle-image")) {
              toggle.querySelector(".navbar-dropdown-toogle-image").style.transform = isOpen
                ? "rotate(0deg)"
                : "rotate(180deg)"
              toggle.querySelector(".navbar-dropdown-toogle-image").style.transition = "transform 0.2s"
            }

            // Toggle the angle-down icon if it exists
            const angleIcon = toggle.querySelector(".fa-angle-down")
            if (angleIcon) {
              angleIcon.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)"
              angleIcon.style.transition = "transform 0.2s"
            }
          }
        })
      })
    }

    // Setup user dropdown
    const setupUserDropdown = () => {
      const userDropdown = document.querySelector(".userlogin")
      if (userDropdown) {
        const toggle = userDropdown.querySelector(".user-login-toggle")
        const dropdownList = userDropdown.querySelector(".user-dropdown-list")

        if (!toggle || !dropdownList) return

        // For desktop: handle hover
        userDropdown.addEventListener("mouseenter", () => {
          if (window.innerWidth >= 992) {
            // Only for desktop
            dropdownList.style.display = "block"
          }
        })

        userDropdown.addEventListener("mouseleave", () => {
          if (window.innerWidth >= 992) {
            // Only for desktop
            setTimeout(() => {
              if (!userDropdown.matches(":hover")) {
                dropdownList.style.display = "none"
              }
            }, 100)
          }
        })

        // For mobile: handle click
        toggle.addEventListener("click", (e) => {
          if (window.innerWidth < 992) {
            // Only for mobile
            e.preventDefault()
            e.stopPropagation()

            // Toggle this dropdown
            const isOpen = dropdownList.style.display === "block"
            dropdownList.style.display = isOpen ? "none" : "block"
          }
        })
      }
    }

    // Setup Zonal Chapter dropdown specifically
    const setupZonalChapterDropdown = () => {
      // Find the specific Zonal Chapter toggle and its dropdown
      const zonalToggle = document.querySelector(".sub-navbar-toogle")
      const zonalDropdownList = document.querySelector(".nav-dropdown-lists.d-1")
      const parentDropdown = document.querySelector(".sub-dropdown").closest(".nav-dropdown")
      const parentDropdownList = document.querySelector(".sub-dropdown").closest(".nav-dropdown-list")

      if (!zonalToggle || !zonalDropdownList || !parentDropdown || !parentDropdownList) return

      // Initially hide the zonal dropdown
      zonalDropdownList.style.display = "none"

      // For desktop: handle hover on the parent dropdown
      parentDropdown.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 992) {
          parentDropdownList.style.display = "block"
        }
      })

      // For desktop: handle hover on the toggle element
      zonalToggle.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 992) {
          zonalDropdownList.style.display = "block"
          parentDropdownList.style.display = "block"

          // Add arrow indicator
          const arrow = zonalToggle.querySelector(".navbar-dropdown-toogle-image")
          if (arrow) {
            arrow.style.transform = "rotate(180deg)"
            arrow.style.transition = "transform 0.2s"
          }
        }
      })

      // Handle mouseleave for the toggle
      zonalToggle.addEventListener("mouseleave", () => {
        if (window.innerWidth >= 992) {
          // Don't hide immediately, check if cursor moved to the dropdown
          setTimeout(() => {
            if (!zonalDropdownList.matches(":hover")) {
              zonalDropdownList.style.display = "none"

              // Reset arrow indicator
              const arrow = zonalToggle.querySelector(".navbar-dropdown-toogle-image")
              if (arrow) {
                arrow.style.transform = "rotate(0deg)"
              }
            }
          }, 50)
        }
      })

      // Also add hover to the dropdown list itself to keep it open when hovering
      zonalDropdownList.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 992) {
          zonalDropdownList.style.display = "block"
          parentDropdownList.style.display = "block"

          // Keep arrow rotated
          const arrow = zonalToggle.querySelector(".navbar-dropdown-toogle-image")
          if (arrow) {
            arrow.style.transform = "rotate(180deg)"
          }
        }
      })

      zonalDropdownList.addEventListener("mouseleave", () => {
        if (window.innerWidth >= 992) {
          zonalDropdownList.style.display = "none"

          // Reset arrow indicator
          const arrow = zonalToggle.querySelector(".navbar-dropdown-toogle-image")
          if (arrow) {
            arrow.style.transform = "rotate(0deg)"
          }
        }
      })

      // For mobile: handle click
      zonalToggle.addEventListener("click", (e) => {
        if (window.innerWidth < 992) {
          e.preventDefault()
          e.stopPropagation()

          // Toggle this dropdown
          const isOpen = zonalDropdownList.style.display === "block"
          zonalDropdownList.style.display = isOpen ? "none" : "block"

          // Toggle arrow indicator
          const arrow = zonalToggle.querySelector(".navbar-dropdown-toogle-image")
          if (arrow) {
            arrow.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)"
            arrow.style.transition = "transform 0.2s"
          }
        }
      })
    }

    // Initialize everything
    setupMainDropdowns()
    setupUserDropdown()
    setupZonalChapterDropdown()

    // Cleanup
    return () => {
      menuButton.removeEventListener("click", handleMenuClick)
      navOverlay.removeEventListener("click", handleOverlayClick)
      window.removeEventListener("resize", handleResize)
      if (navCloseButton) {
        navCloseButton.removeEventListener("click", handleOverlayClick)
      }
      // Cleanup would ideally remove all dropdown event listeners too
      // but for simplicity we're not doing that here
    }
  }, [])



  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <>
      <meta charSet="utf-8" />
      <title>Association of Minimal Access Surgeons of India - AMASI</title>
      <meta
        content="The minimal access surgeons of India is dedicated to the service of mankind and play a pivotal role in preventing and curing the diseases through the art of minimal invasive surgery."
        name="description"
      />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta content="Webflow" name="generator" />
      <link href="assets/css/amasi.webflow.47ac59380.css" rel="stylesheet" type="text/css" />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
        rel="stylesheet"
        type="text/css"
      />
      <link href="https://fonts.gstatic.com/" rel="preconnect" crossOrigin="anonymous" />
      <link href="assets/image/667186ddcec7b07cda4aa506_amasi_logo 1.png" rel="shortcut icon" type="image/x-icon" />
      <link
        href="assets/image/66712a83ccf4e64be43d1817/6671871c56576c66c413a0d2_amasi_logo%202"
        rel="apple-touch-icon"
      />

      <div
        data-animation="over-left"
        data-collapse="medium"
        data-duration={400}
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navigation-bar w-nav header_application"
      >
        <div className="navbar-script w-embed w-script "></div>
        <div className="w-embed w-script "></div>
        <div className="container">
          <div className="w-embed">
            <style
              dangerouslySetInnerHTML={{
                __html:
                  '\n                    .w-nav[data-animation="over-left"] .w-nav-overlay,\n                    .w-nav[data-animation="over-left"] [data-nav-menu-open] {\n                        z-index: 999;\n                    }\n\n                    @media (min-width: 1200px) {\n                        .container {\n                            max-width: 1140px;\n                        }\n                    }\n\n                    @media (min-width: 1400px) {\n                        .container {\n                            max-width: 1320px !important;\n                        }\n                    }\n\n                    @media screen and (max-width: 1199px) {\n                        .container {\n                            max-width: 100% !important;\n                        }\n                    }\n\n                    @media screen and (max-width: 1199px) {\n                        .logo-block {\n                            max-width: 80px;\n                        }\n\n                        .nav-link {\n                            font-size: 0.85rem;\n                        }\n\n                        .dropdown-link {\n                            font-size: 0.85rem;\n                        }\n\n                        .sub-dropdown-text {\n                            font-size: 0.85rem;\n                        }\n\n                        .nav-dropdown-text {\n                            font-size: 0.85rem;\n                        }\n                    }\n\n                    .menu-button .w-nav-button .w--open+#navoverlay {\n                        display: block\n                    }\n                    \n                    /* Mobile menu styles */\n                    @media screen and (max-width: 991px) {\n                        .w-nav-menu {\n                            background-color: #fff;\n                            padding: 20px;\n                            box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n                                            overflow-y: auto;\n                        }\n                        \n                        .w--nav-menu-open {\n                            display: block !important;\n                            position: absolute;\n                            top: 100%;\n                            left: 0;\n                            right: 0;\n                            z-index: 1000;\n                        }\n                        \n                        .nav-close {\n                            display: block;\n                            position: absolute;\n                            top: 10px;\n                            right: 10px;\n                        }\n                        \n                        .nav-dropdown-list {\n                            position: static !important;\n                            box-shadow: none !important;\n                            padding-left: 20px !important;\n                        }\n                        \n                        .nav-link, .nav-dropdown-text {\n                            padding: 10px 0 !important;\n                            display: block !important;\n                        }\n                    }\n                ',
              }}
            />
          </div>
          <div className="header-flex">
            <div
              id="menu-button"
              ref={menuButtonRef}
              data-w-id="d7789f71-efa4-aeb5-1b4e-848b41339024"
              className="menu-button w-nav-button"
            >
              <i className="fa fa-bars"></i>
            </div>
            <Link to={`${ROUTE_BASE_URL}/user-member-application-list`}>
              <div className="logo-block">
                <img src={logo || "/placeholder.svg"} loading="lazy" alt="logo" className="logo" />
              </div>
            </Link>
            <div className="header-content">
              <div id="navoverlay" ref={navOverlayRef} className="nav-overlay" />
              <div className="header-top">
                <div className="header-social">
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/amasi.ec"
                      target="_blank"
                      className="header-social-link w-inline-block"
                      rel="noreferrer"
                    >
                      <div className="w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                          <path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path>
                        </svg>
                      </div>
                    </a>
                    <a href="https://www.amasi.org/" className="header-social-link w-inline-block">
                      <div className="w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                          <path d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"></path>
                        </svg>
                      </div>
                    </a>
                    <a href="https://www.amasi.org/" className="header-social-link w-inline-block">
                      <div className="w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <div className="contact-info">
                    <div className="contact-info-list">
                      <a href="tel:+917358105244" className="header-social-link w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7 4V20H17V4H7ZM6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17Z"></path>
                          </svg>
                        </div>
                        <div>+91 7358105244</div>
                      </a>
                    </div>
                    <div className="contact-info-list">
                      <a href="mailto:amasi.india@gmail.com" className="header-social-link w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"></path>
                          </svg>
                        </div>
                        <div>amasi.india@gmail.com</div>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <a
                  href="https://airtable.com/appxRnSu9nbcbKBIX/shrgc6Q9XpG5W3QHo/tbl7Y4U7mEcm4IutI"
                  target="_blank"
                  className="nav-link space w-nav-link mobile_hide"
                  rel="noreferrer"
                >
                  Track Your FMAS Certificates 2024
                </a> */}
                { !isAuthenticated && localStorage.getItem("loginMemberUserId") === null ? 
                <Link
                  id="login-btn"
                  data-w-id="d7789f71-efa4-aeb5-1b4e-848b4133903f"
                  to={`${ROUTE_BASE_URL}/user-login`}
                  className="nav-login-in w-inline-block"
                >
                  <div className="w-embed login_icon_pad3">
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" />
                    </svg>
                  </div>
                  <div>Login/Signup</div>
                </Link>:
                <div className="login-dropdown" ref={dropdownRef}>
                  <div
                    id="login-btn"
                    onClick={() => setOpen(!open)}
                    className="  login-toggle after_login"
                  >
                    <div className="w-embed login_icon_pad3">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" />
                      </svg> */}
                      <div className="user_div">
                        <img src={localStorage.getItem("loginMemberUserImage") !== null ? localStorage.getItem("loginMemberUserImage") : `${"../../assets/images/user_image.png"}`}
                          width={50}
                          height={50}
                          className="user-photo rounded img-thumbnail rounded-circle profile-menu-size" alt="User Profile" />
                      </div>
                    </div>
                    <div>{localStorage.getItem("loginMemberUserName")}</div>
                  </div>

                  {open && (
                    <div className="login-dropdown-menu">
                      <Link to={`${ROUTE_BASE_URL}/user-member-application-preview/${encryptSlug(`${localStorage.getItem("loginMemberUserId")}`)}`} className="dropdown-link">
                        My Profile
                      </Link>
                      <Link to={`${ROUTE_BASE_URL}/user-member-application-certificate/${encryptSlug(`${localStorage.getItem("loginMemberUserId")}`)}`} className="dropdown-link">
                        My Certificate
                      </Link>
                      {localStorage.getItem("isEventMember") &&
                      <a 
                       href={`https://events.amasi.org/events/user-events/${encryptSlug(
                        `${localStorage.getItem("loginEventMemberEmail")}`
                      )}`}
                      target="_blank"
                      className="dropdown-link">
                        My Events
                      </a>}
                      <a href={`https://www.amasi.org`}
                        onClick={() => {
                          logOut();
                          // handleMenuClick();
                        }} className="dropdown-link">
                        Logout
                      </a>
                    </div>
                  )}
                </div>
                }
                <div data-hover="false" data-delay={0} id="profile-menu" className="userlogin w-dropdown">
                  <div className="user-login-toggle w-dropdown-toggle">
                    <div className="user-icon">
                      <img
                        src="assets/image/667189c05e7c6094d8a5fcaf_user_placeholder.png"
                        loading="lazy"
                        alt=""
                        className="logged-user"
                      />
                    </div>
                    <div id="user-name" className="user-name" />
                    <div className="icon w-icon-dropdown-toggle" />
                  </div>
                  <nav className="user-dropdown-list w-dropdown-list">
                    <div className="user_full_name_wrapper">
                      <div id="user-full-name" className="user_full_name" />
                    </div>
                    <a id="my-profile" href="https://www.amasi.org/" className="user-drop-link w-dropdown-link">
                      My Profile
                    </a>
                    <a href="https://mypage.amasi.org/my-certificate.php" className="user-drop-link w-dropdown-link">
                      My Certificate
                    </a>
                    <a href="https://www.amasi.org/" className="user-drop-link w-dropdown-link">
                      Change Password
                    </a>
                    <a href="https://www.amasi.org/index7c07.html?action=logout" className="user-drop-link w-dropdown-link">
                      Logout
                    </a>
                  </nav>
                </div>
              </div>
              <nav role="navigation" ref={navMenuRef} className="header-nav w-nav-menu">
                <div className="app-nav">
                  <div className="menu-main-menu">
                    <a href="https://www.amasi.org/" aria-current="page" className="nav-link w-nav-link w--current">
                      Home
                    </a>
                    <div data-hover="true" data-delay={0} className="nav-dropdown w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <div className="nav-dropdown-text">
                          About AMASI <i className="fa fa-angle-down"></i>
                        </div>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a href="https://www.amasi.org/history-of-amasi" className="dropdown-link w-dropdown-link">
                          History of AMASI
                        </a>
                        <a href="https://www.amasi.org/executive-committee" className="dropdown-link w-dropdown-link">
                          Executive Committee
                        </a>
                        <div data-hover="true" data-delay={0} className="sub-dropdown w-dropdown">
                          <div
                            data-w-id="d7789f71-efa4-aeb5-1b4e-848b41339063"
                            className="sub-navbar-toogle w-dropdown-toggle"
                          >
                            <div className="sub-dropdown-text">
                              Zonal Chapter of AMASI <i class="fa fa-angle-right menu_right_pos"></i>
                            </div>
                            <div className="navbar-dropdown-toogle-image static w-icon-dropdown-toggle"></div>
                          </div>
                          <nav className="zonal-chapter-list d-1 w-dropdown-list">
                            <a
                              href="https://www.amasi.org/zonal-executive-comittee/north-zone"
                              className="dropdown-link f-1 w-dropdown-link"
                            >
                              North Zone
                            </a>
                            <a
                              href="https://www.amasi.org/zonal-executive-comittee/south-zone"
                              className="dropdown-link f-1 w-dropdown-link"
                            >
                              South Zone
                            </a>
                            <a
                              href="https://www.amasi.org/zonal-executive-comittee/east-zone"
                              className="dropdown-link f-1 w-dropdown-link"
                            >
                              East Zone
                            </a>
                            <a
                              href="https://www.amasi.org/zonal-executive-comittee/west-zone"
                              className="dropdown-link f-1 w-dropdown-link"
                            >
                              West Zone
                            </a>
                            <a
                              href="https://www.amasi.org/zonal-executive-comittee/central-zone"
                              className="dropdown-link f-1 w-dropdown-link"
                            >
                              Central Zone
                            </a>
                          </nav>
                        </div>
                      </nav>
                    </div>
                    <div data-hover="true" data-delay={0} className="nav-dropdown w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <div className="nav-dropdown-text">
                          Membership <i className="fa fa-angle-down"></i>
                        </div>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a href="https://www.amasi.org/why-join-amasi" className="dropdown-link w-dropdown-link">
                          Why join AMASI
                        </a>
                        <a href="https://www.amasi.org/eligibility" className="dropdown-link w-dropdown-link">
                          Eligibility
                        </a>
                        <a
                          href="https://www.amasi.org/the-fee-structure"
                          className="dropdown-link w-dropdown-link"
                        >
                          The Fee Structure
                        </a>
                        <a
                          href="https://amasi.healthconnectdigital.com/"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          Application for membership
                        </a>
                      </nav>
                    </div>
                    <div data-hover="true" data-delay={0} className="nav-dropdown w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <a href="https://www.amasi.org/cme-program" className="nav-dropdown-text">
                          CME Program <i className="fa fa-angle-down"></i>
                        </a>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a
                          href="https://amasi.my.canva.site/amasi-online-cme-series"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          Upcoming CME Programme
                        </a>
                        <a
                          href="https://amasi.my.canva.site/the-past-cme-programme"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          Past CME programme
                        </a>
                        <a href="https://www.amasi.org/a-day-with-a-master" className="dropdown-link w-dropdown-link">
                          A day with a Master
                        </a>
                        <a
                          href="https://amasiclick.org/"
                          target="_blank"
                          className="dropdown-link hide w-dropdown-link"
                          rel="noreferrer"
                        >
                          AMASI LENS
                        </a>
                      </nav>
                    </div>
                    <div data-hover="true" data-delay={0} className="nav-dropdown w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <div className="nav-dropdown-text">
                          Events <i className="fa fa-angle-down"></i>
                        </div>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a href="https://www.amasi.org/events-calendar" className="dropdown-link w-dropdown-link">
                          Events Calendar
                        </a>
                        <a href="https://www.amasi.org/upcoming-events" className="dropdown-link w-dropdown-link">
                          Upcoming Events
                        </a>
                        <a href="https://www.amasi.org/zonal-events" className="dropdown-link w-dropdown-link">
                          Zonal Events
                        </a>
                        <a
                          href="https://amasi.my.canva.site/amasi-zonal-award"
                          className="dropdown-link w-dropdown-link"
                        >
                          AMASI Zonal Awards
                        </a>
                        <a
                          href="https://www.amasi.org/application-forms-mous-for-academic-events"
                          className="dropdown-link w-dropdown-link"
                        >
                          Application Forms &amp; MOU's for Academic Events
                        </a>
                        <a href="https://www.amasi.org/event-reports" className="dropdown-link hide w-dropdown-link">
                          Event Reports
                        </a>
                        <a href="https://www.amasi.org/past-events" className="dropdown-link w-dropdown-link">
                          Past events
                        </a>
                      </nav>
                    </div>
                    <div data-hover="true" data-delay={0} className="nav-dropdown w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <div className="nav-dropdown-text">
                          Academy <i className="fa fa-angle-down"></i>
                        </div>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a href="https://www.amasi.org/skill-course" className="dropdown-link w-dropdown-link">
                          FMAS - Skill Course
                        </a>
                        <a href="https://www.amasi.org/mmas-skill-course" className="dropdown-link w-dropdown-link">
                          MMAS - Skill Course
                        </a>
                        <a href="https://www.amasi.org/amasi-travelling-fellowship" className="dropdown-link w-dropdown-link">
                          AMASI&nbsp;Travelling&nbsp;Fellowship
                        </a>
                        <a
                          href="https://www.amasi.org/amasi-bursary-award-and-application-guidelines"
                          className="dropdown-link w-dropdown-link"
                        >
                          AMASI Bursary Award and Application Guidelines
                        </a>
                        <a href="https://www.amasi.org/amasi-bursary-awardees" className="dropdown-link w-dropdown-link">
                          AMASI Bursary Awardees
                        </a>
                        <a
                          data-w-id="d7789f71-efa4-aeb5-1b4e-848b413390ac"
                          href="https://www.amasi.org/"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          AMASI Video Library
                        </a>
                        <a href="https://www.amasi.org/photo-gallery" className="dropdown-link w-dropdown-link">
                          AMASI Photo Gallery
                        </a>
                        <a href="https://www.amasi.org/amasi-accounts" className="dropdown-link w-dropdown-link">
                          AMASI Accounts
                        </a>
                        <a href="https://www.amasi.org/oration" className="dropdown-link w-dropdown-link">
                          Orations
                        </a>
                      </nav>
                    </div>
                    <a
                      href="https://amasicon2025.com/"
                      target="_blank"
                      className="nav-link w-nav-link"
                      rel="noreferrer"
                    >
                      Annual Conference
                    </a>
                    <a href="https://amasiclick.org/" className="nav-link w-nav-link">
                      AMASI LENS
                    </a>
                    <a href="https://www.amasi.org/contact-us" className="nav-link w-nav-link">
                      Contact Us
                    </a>
                    <div data-hover="true" data-delay={0} className="nav-dropdown hide w-dropdown">
                      <div className="navbar-toogle w-dropdown-toggle">
                        <div className="navbar-dropdown-toogle-image w-icon-dropdown-toggle" />
                        <div className="nav-dropdown-text">AMASI Click</div>
                      </div>
                      <nav className="nav-dropdown-list w-dropdown-list">
                        <a
                          href="https://web.communa.app/amasi"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          AMASI Click
                        </a>
                        <a
                          href="https://amasi.my.canva.site/amasic-click-winners"
                          target="_blank"
                          className="dropdown-link w-dropdown-link"
                          rel="noreferrer"
                        >
                          2024 Award Winners
                        </a>
                      </nav>
                    </div>
                    <a
                      href="https://airtable.com/appxRnSu9nbcbKBIX/shrgc6Q9XpG5W3QHo/tbl7Y4U7mEcm4IutI"
                      target="_blank"
                      className="nav-link hide w-nav-link"
                      rel="noreferrer"
                    >
                      Track Your FMAS Certificates 2024
                    </a>
                  </div>
                </div>
                <a data-w-id="d7789f71-efa4-aeb5-1b4e-848b413390bc" href="https://www.amasi.org/" className="nav-close w-inline-block">
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                    </svg>
                  </div>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header

// const Header = () => {
//     return (
//         <>
//             <section className="user_div_total">
//                 <div className="container-fluid pt-3 pb-3 bg-white ">
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-md-9">
//                                 <div className="header_div_top">
//                                     <Link to={`${ROUTE_BASE_URL}/user-member-application-list`}>
//                                     <div>
//                                         <img src={logo} width={70} alt="amasi" />
//                                         {/* <img src="https://amasi.healthconnectdigital.com/img/amasi_new_logo.png" alt="" /> */}
//                                     </div>
//                                     </Link>
//                                     <div className="associta_div">
//                                         <h3 className="text-dark">Association of Minimal Access Surgeons of India</h3>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-md-3 contact_div_header ">
//                                 <span class="btn btn-outline-primary mr-1" title=""> Contact Support</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );

// }


// export default Header
